/**
 * Car Filter Store
 * Manages car filtering state
 */

import type { CarFilters } from '@/types'
import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

interface FilterState {
	filters: CarFilters
	setFilters: (filters: Partial<CarFilters>) => void
	resetFilters: () => void
	updateFilter: <K extends keyof CarFilters>(
		key: K,
		value: CarFilters[K]
	) => void
}

const initialFilters: CarFilters = {
	category: undefined,
	transmission: undefined,
	fuelType: undefined,
	priceRange: undefined,
	seats: undefined,
	features: undefined,
	availability: true,
	sortBy: 'price-asc',
}

export const useFilterStore = create<FilterState>()(
	devtools(
		persist(
			set => ({
				filters: initialFilters,

				setFilters: newFilters =>
					set(state => ({
						filters: { ...state.filters, ...newFilters },
					})),

				resetFilters: () => set({ filters: initialFilters }),

				updateFilter: (key, value) =>
					set(state => ({
						filters: { ...state.filters, [key]: value },
					})),
			}),
			{
				name: 'tattersall-filters',
			}
		),
		{ name: 'FilterStore' }
	)
)
